import { useEffect, useRef } from "react";

const CustomScriptWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    const scriptId = "custom-script";

    // Prevent multiple script injections
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src = "https://emrldtp.cc/MTc1ODM.js?t=17583";
      document.head.appendChild(script);
    }

    return () => {
      // Cleanup widget content
      if (widgetRef.current) {
        widgetRef.current.innerHTML = "";
      }
    };
  }, []);

  return <div ref={widgetRef} id="custom-widget-container"></div>;
};

export default CustomScriptWidget;
